import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main className="pt-20">
        <div className="w-full px-4 md:px-6 py-20">
          <div className="max-w-lg mx-auto text-center">
            <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-white/[0.03] border border-white/5">
              <i className="ri-error-warning-line text-4xl text-foreground-500"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">404</h1>
            <p className="text-foreground-500 mb-8 text-sm leading-relaxed">
              您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页浏览更多精彩内容。
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-400 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-home-line"></i>
              返回首页
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}